import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {destroy$} from '../../components/destroyable';
import {Widget} from '../../components/layout/widget/widget';
import {WidgetLinkingGroupService} from '../../components/widget-linking-group';
import {Side} from '../../enums/side';
import {FloatWidgetFactory} from '../../pages/dashboard/float-layout/float-widget.factory';
import {DEX_LP_TRADE_WIDGET_TYPE_ID} from '../dex-lp-trade-widget/dex-lp-trade-widget-type-id';
import {DexLpTradeWidgetSettingsDef} from '../dex-lp-trade-widget/settings/index';
import {DexTrancheDetailsWidget} from './dex-tranche-details-widget';
import {DexTrancheDetailsWidgetImplementation} from './dex-tranche-details-widget.implementation';

@Component({
    selector:        'dex-tranche-details-widget',
    templateUrl:     './dex-tranche-details-widget.component.html',
    styleUrls:       ['./dex-tranche-details-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      false,
    viewProviders:   [
        FloatWidgetFactory
    ]
})
export class DexTrancheDetailsWidgetComponent {

    public readonly destroy$ = destroy$();

    public readonly widget = inject(Widget) as DexTrancheDetailsWidget;
    public readonly widgetImpl: DexTrancheDetailsWidgetImplementation = this.widget.implementationInstance;

    private readonly widgetLinkingGroupService = inject(WidgetLinkingGroupService);
    private readonly floatWidgetFactory = inject(FloatWidgetFactory);

    public handleToggleCollapsed(): void {
        this.widgetImpl.toggleFeatureCollapsed(false).pipe(
            takeUntil(this.destroy$)
        ).subscribe();
    }

    public handleSymbolClick(symbol: string): void {
        const widget = this.widget;

        this.widgetLinkingGroupService.setLinkingGroupSettings(
            widget.linkingGroupId,
            widget.tabId,
            {
                trancheSymbol: symbol
            } as any
        );
    }

    public handleTradeClick(side: Side): void {
        const symbol = this.widgetImpl.$tranche().unitDeliverable.symbol;

        this.floatWidgetFactory.createFloatWidget<DexLpTradeWidgetSettingsDef>(
            DEX_LP_TRADE_WIDGET_TYPE_ID,
            {
                title:     null,
                side,
                symbol
            }
        );
    }

}
